import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const clearSectionFn = /* @__PURE__ */ createRecipe('clear-section', {}, [])

const clearSectionVariantMap = {}

const clearSectionVariantKeys = Object.keys(clearSectionVariantMap)

export const clearSection = /* @__PURE__ */ Object.assign(memo(clearSectionFn.recipeFn), {
  __recipe__: true,
  __name__: 'clearSection',
  __getCompoundVariantCss__: clearSectionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: clearSectionVariantKeys,
  variantMap: clearSectionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, clearSectionVariantKeys)
  },
  getVariantProps: clearSectionFn.getVariantProps,
})